import React, { forwardRef } from 'react';
import { Text as RNText, type TextProps as RNTextProps } from 'react-native';

import { FONT_SCALE_CAP, type TextScale } from './fontScale';

export type TextProps = RNTextProps & {
  /** Which font-scale cap applies. Defaults to `chrome` (1.5x). */
  scale?: TextScale;
};

/** Instance type, so `useRef<Text>` keeps meaning the native Text handle. */
export type Text = RNText;

/**
 * The app's Text. Identical to react-native's Text except that OS font
 * scaling is capped per `scale` (an explicit `maxFontSizeMultiplier` wins).
 * Import from '@/components/common/text', never from 'react-native'.
 */
export const Text = forwardRef<RNText, TextProps>(function Text(
  { scale = 'chrome', maxFontSizeMultiplier, ...rest },
  ref,
) {
  return (
    <RNText
      ref={ref}
      maxFontSizeMultiplier={maxFontSizeMultiplier ?? FONT_SCALE_CAP[scale]}
      {...rest}
    />
  );
});
